import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "id"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DraggableComponent',
  props: {
    id: {},
    type: {},
    dragGroupClass: {},
    class: {}
  },
  emits: ["click", "drop"],
  setup(__props: any, { emit: emits }) {

const props = __props;



const draggableClass = {
	insert: 'dragging',
	swap: 'dragover',
	placeholder: 'dragging-placeholder',
	dragFrom: 'dragfrom'
};



const dragPlaceholder = ref<HTMLDivElement>();

function dragStart(e: DragEvent) {
	const element = e.currentTarget as HTMLDivElement;
	if (props.type === 'insert') {
		element.classList.add(draggableClass.insert);
		dragPlaceholder.value?.classList.add(draggableClass.placeholder);
	}
	element.classList.add(draggableClass.dragFrom);
}

function dragEnd(e: DragEvent) {
	const element = e.currentTarget as HTMLDivElement;
	if (props.type === 'insert') {
		element.classList.remove(draggableClass.insert);
		dragPlaceholder.value?.classList.remove(draggableClass.placeholder);
	}
	element.classList.remove(draggableClass.dragFrom);
}

function dragEnter(e: DragEvent) {
	if (props.type === 'swap') {
		const element = e.currentTarget as HTMLDivElement;
		const from = getElementByClassName<HTMLDivElement>(draggableClass.dragFrom);
		if (from?.id === element.id) {
			return;
		}
		element.classList.add(draggableClass.swap);
	}
}

function dragLeave(e: DragEvent) {
	if (props.type === 'swap') {
		const element = e.currentTarget as HTMLDivElement;
		const rect = element.getBoundingClientRect();
		if (
			e.x <= Math.floor(rect.x) ||
			e.x >= Math.floor(rect.x + rect.width) ||
			e.y <= Math.floor(rect.y) ||
			e.y >= Math.floor(rect.y + rect.height)
		) {
			element.classList.remove(draggableClass.swap);
		}
	}
}

function dragOver(e: DragEvent) {
	e.preventDefault();
	const currentElement = e.currentTarget as HTMLDivElement;

	if (props.type === 'insert') {
		const draggingPlaceholder = getElementByClassName<HTMLDivElement>(draggableClass.placeholder);
		if (!draggingPlaceholder) {
			return;
		}

		const firstElement = getElementByClassName<HTMLDivElement>(props.dragGroupClass);
		if (!firstElement) {
			return;
		}

		const top = firstElement.getBoundingClientRect().y || 0;
		const rect = currentElement.getBoundingClientRect();
		const center = rect.y + rect.height / 2;
		const isLower = e.y < center;
		if (isLower) {
			draggingPlaceholder.style.transform = `translateY(${rect.y + rect.height - top}px)`;

			const elements = document.getElementsByClassName(props.dragGroupClass);
			if (elements && elements.length) {
				for (let i = 0; i < elements.length; i++) {
					const element = elements.item(i);
					if (element && element.id === currentElement.id) {
						draggingPlaceholder.id =
							i === elements.length - 1 ? '' : elements.item(i + 1)?.id || currentElement.id;
					}
				}
			}
		} else {
			draggingPlaceholder.style.transform = `translateY(${rect.y - top}px)`;
			draggingPlaceholder.id = currentElement.id;
		}
	} else {
		const from = getElementByClassName<HTMLDivElement>(draggableClass.dragFrom);
		if (from?.id === currentElement.id) {
			return;
		}
		currentElement.classList.add(draggableClass.swap);
	}
}

function drop(e: DragEvent) {
	e.preventDefault();

	const to = e.currentTarget as HTMLDivElement;
	const from = getElementByClassName<HTMLDivElement>(draggableClass.dragFrom);
	if (!from) {
		return;
	}

	let fromID = from.id,
		toID = '';
	if (props.type === 'swap') {
		toID = to.id;
		const elements = document.getElementsByClassName(props.dragGroupClass);
		if (elements && elements.length) {
			for (let i = 0; i < elements.length; i++) {
				const element = elements.item(i);
				if (element) {
					element.classList.remove(draggableClass.swap);
				}
			}
		}
	} else if (props.type === 'insert') {
		const draggingPlaceholder = getElementByClassName<HTMLDivElement>(draggableClass.placeholder);
		if (!draggingPlaceholder) {
			return;
		}

		toID = draggingPlaceholder.id;
	}

	emits('drop', fromID, toID);
}

function getElementByClassName<T>(className: string) {
	const element = document.getElementsByClassName(className);
	if (!element || !element.length) {
		return;
	}
	return element.item(0) as T;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      "aria-label": _ctx.id,
      id: _ctx.id,
      class: _normalizeClass(`${_ctx.dragGroupClass} ${props.class} [&.dragging]:opacity-4 [&.dragover]:!bg-gray-700 [&.dragover]:!text-white`),
      onClick: _cache[0] || (_cache[0] = (e) => _ctx.$emit('click', e)),
      draggable: "true",
      onDragstart: dragStart,
      onDragend: dragEnd,
      onDragover: dragOver,
      onDragenter: dragEnter,
      onDragleave: dragLeave,
      onDrop: drop
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 42, _hoisted_1),
    _createElementVNode("div", {
      ref_key: "dragPlaceholder",
      ref: dragPlaceholder,
      class: "w-full h-1 bg-orange-300 absolute z-20 rounded-lg top-0 left-0 hidden [&.dragging-placeholder]:block"
    }, null, 512)
  ], 64))
}
}

})